<div class="error-message" *ngIf="showClienteError && showEstablecimientoError">Por favor, selecciona un establecimiento y un cliente</div>
<div class="error-message" *ngIf="showClienteError && !showEstablecimientoError">Por favor, selecciona un cliente</div>
<div class="error-message" *ngIf="!showClienteError && showEstablecimientoError">Por favor, selecciona un establecimiento</div>
<div class="ok-message fade-out" *ngIf="!showClienteError && !showEstablecimientoError && dispositivoCreado !errorFinal">El dispositivo se ha creado correctamente</div>
<div class="error-message fade-out" *ngIf="errorFinal">{{errorMessage}}</div>

<ng-container *ngIf="errorMessage !== ''">
    <div class="error-container">
        <div class="mensaje-error-container">
            <div class="mensaje-error">{{ errorMessage }}</div>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<div class="container">
    <div class="header">
        <div class="header-content">
            <span class="font20">NUEVO DISPOSITIVO-INSTALACIÓN</span>
            <button mat-icon-button matTooltip="Registrar nuevo dispositivo" class="gurdar-btn" (click)="guardarDispositivo()" [disabled]="waitAfterSave">
                <mat-icon>save</mat-icon>
            </button>
        </div>
        <span class="header-text font14">Formulario de alta de dispositivos DataBeer</span>
    </div>

    <div class="body">

        <!--DISPOSITIVO-->
        <div class="datos-instalacion">
            <div class="datos-dispositivo-header">
                <span>DATOS DEL DISPOSITIVO</span>
            </div>

            <mat-form-field class="etiqueta-container marginTop20">
                <mat-label class="etiqueta-label">Etiqueta</mat-label>
                <input matInput type="text" [(ngModel)]="etiqueta" placeholder="Si queda vacio será el código de referencia">
                <button *ngIf="etiqueta" matSuffix mat-icon-button aria-label="Clear" (click)="etiqueta=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <mat-form-field class="descripcion-container">
                <mat-label class="descripcion-label">Descripcion</mat-label>
                <textarea matInput type="text" [(ngModel)]="descripcion" placeholder="Descripción del dispositivo"></textarea>
                <button *ngIf="descripcion" matSuffix mat-icon-button aria-label="Clear" (click)="descripcion=''">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <div class="estado-container marginTopM10">
                <span class="labelCustom">Estado: *</span>
                <mat-form-field class="formFieldCustom">
                    <mat-label>-Elige una opción-</mat-label>
                    <mat-select [(value)]="selectedEstado" name="est">
                      <mat-option *ngFor="let est of estado" [value]="est.value">
                        {{est.name}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="marginBottom20">
                <mat-checkbox [(ngModel)]="configuracionFinalizada" color="warn" class="marginLeftM10">
                    <span class="custom">Configuración del dispositivo finalizada</span>
                </mat-checkbox>
            </div>

            <div class="referencia-container">
                <span class="labelCustom">Referencia: </span><span> Código DBXXX del dispositivo</span>
                <mat-form-field appearance="outline" class="latitud-value marginTop10">
                    <input matInput type="text" [readonly]="true" value="Generado automáticamente"/>
                </mat-form-field>
            </div>

            <div class="token-container">
                <span class="labelCustom">Token de seguridad: </span><span> Cadena única de acceso seguro al dispositivo</span>
                <mat-form-field appearance="outline" class="latitud-value marginTop10">
                    <input matInput type="text" [readonly]="true" value="Generado automáticamente"/>
                </mat-form-field>
            </div>

            <!--<div class="mode-version-container">
                <span class="labelCustom">Modelo - Versión: </span><span> Modelo y versión del dispositivo</span>
                <mat-form-field class="formFieldCustom">
                    <mat-label>-Elige una opción-</mat-label>
                    <mat-select [disabled]="true" [(ngModel)]="selectedVersion" name="modVer">
                      <mat-option *ngFor="let modVer of modeloVersion" [value]="modVer.value">
                        {{modVer.viewValue}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>-->

            <mat-form-field class="etiqueta-container marginTop0">
                <mat-label class="etiqueta-label">Nº de serie</mat-label>
                <input matInput type="text" [(ngModel)]="nSerie" placeholder="Ejemplo: VI1807160530V22">
                <button *ngIf="nSerie" matSuffix mat-icon-button aria-label="Clear" (click)="nSerie=''">
                  <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <mat-form-field class="etiqueta-container marginTop0">
                <mat-label class="etiqueta-label">Nº SIM</mat-label>
                <input matInput type="text" [(ngModel)]="nSIM" placeholder="Ejemplo: 18071605300000 000 0">
                <button *ngIf="nSIM" matSuffix mat-icon-button aria-label="Clear" (click)="nSIM=''">
                  <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <mat-form-field class="etiqueta-container marginTop0">
                <mat-label class="etiqueta-label">Versión</mat-label>
                <input matInput type="text" [(ngModel)]="version" placeholder="Versión del dispositivo" mask="0">
            </mat-form-field>

            <!--<div class="caracteristicas-container">
                <span class="labelCustom">Características: </span><span> Activar las opciones especiales del dispósitivo</span>
                <div class="multitanque-container marginTop10">
                    <section class="example-section">
                        <mat-checkbox class="example-margin" [(ngModel)]="disabledCheckbox" color="warn">Multitanque</mat-checkbox>
                    </section>
                </div>

                <div class="tanques-container">
                    <div class="tanques-activados-container" *ngIf="disabledCheckbox">
                        <span class="labelCustom">Activar tanques</span>
                        <div class="tanques-activados" *ngIf="disabledCheckbox">
                            <section class="tanque">
                                <mat-checkbox
                                    class="example-margin"
                                    [(ngModel)]="checkedT1"
                                    [disabled]="!disabledCheckbox"
                                    color="warn">
                                Tanque 1
                                </mat-checkbox>
                            </section>
                            <section class="tanque">
                                <mat-checkbox
                                    class="example-margin"
                                    [(ngModel)]="checkedT2"
                                    [disabled]="!disabledCheckbox"
                                    color="warn">
                                Tanque 2
                                </mat-checkbox>
                            </section>
                            <section class="tanque">
                                <mat-checkbox
                                    class="example-margin"
                                    [(ngModel)]="checkedT3"
                                    [disabled]="!disabledCheckbox"
                                    color="warn">
                                Tanque 3
                                </mat-checkbox>
                            </section>
                        </div>
                    </div>
                    <div class="tanques-capacidad-container" *ngIf="disabledCheckbox">
                        <div class="capacidad-titulo">
                            <span class="labelCustom">Capacidad individual (litros)</span>
                        </div>
                        <mat-form-field color="warn" style="margin-top: 24px; width: 65%;">
                            <mat-label>Tanque 1</mat-label>
                            <input matInput placeholder="Litros Tanque 1" [disabled]="!checkedT1" [(ngModel)]="valorTanque1">
                        </mat-form-field>
                        <mat-form-field class="tanque-input" color="warn">
                            <mat-label>Tanque 2</mat-label>
                            <input matInput placeholder="Litros Tanque 2" [disabled]="!checkedT2" [(ngModel)]="valorTanque2">
                        </mat-form-field>
                        <mat-form-field class="tanque-input" color="warn">
                            <mat-label>Tanque 3</mat-label>
                            <input matInput placeholder="Litros Tanque 3" [disabled]="!checkedT3" [(ngModel)]="valorTanque3">
                        </mat-form-field>
                    </div>
                </div>
            </div>-->
                            <!--<section class="tanque">
                                <mat-checkbox
                                    class="example-margin"
                                    [(ngModel)]="checkedT4"
                                    [disabled]="!disabledCheckbox"
                                    color="warn">
                                Tanque 4
                                </mat-checkbox>
                            </section>-->

                        <!--<mat-form-field class="tanque-input" color="warn">
                            <mat-label>Tanque 4</mat-label>
                            <input matInput placeholder="Litros Tanque 4" [disabled]="!checkedT4" [(ngModel)]="valorTanque4">
                        </mat-form-field>-->

        </div>

        <!--INSTALACION-->

        <div class="datos-dispositivo">
            <div class="datos-instalacion-header">
                <span>DATOS DE LA INSTALACIÓN</span>
            </div>

            <!--<div class="etiqueta-container">
                <span class="labelCustom" [ngClass]="{'error-select': showEstablecimientoError}">Establecimiento: * </span>
                <mat-form-field class="formFieldCustom">
                    <mat-label [ngClass]="{'error-select': showEstablecimientoError}">-Elige una opción-</mat-label>
                    <mat-select [(value)]="selectedEstablecimiento" name="est" (selectionChange)="updateEstadoErrorEstablecimiento()">
                        <mat-option *ngFor="let est of establecimientos" [value]="est.value">
                        {{est.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-error *ngIf="showEstablecimientoError"  class="customError">Selecciona un establecimiento</mat-error>
            </div>-->

            <div class="custom1">
                <span class="labelCustom" [ngClass]="{'error-select': showEstablecimientoError}">Establecimiento: * </span>
                <form class="custom2">
                    <mat-form-field class="widht100">
                        <mat-label>Establecimiento</mat-label>
                        <input type="text"
                                placeholder="Elige uno"
                                aria-label="Establecimiento"
                                matInput
                                [formControl]="myControl"
                                [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected($event)">
                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <button *ngIf="myControl.value != ''" matSuffix mat-icon-button aria-label="Clear" (click)="limpiarSeleccion()">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-error *ngIf="showEstablecimientoError"  class="customError">Selecciona un establecimiento</mat-error>
                </form>
            </div>

            <div class="mapa-container">
                <div class="marginBottom20">
                    <span class="labelCustom">Ubicación del establecimiento: </span>
                </div>
                <div id="map" class="height450"></div>
            </div>

            <div class="etiqueta-container">
                <span class="labelCustom">Dirección completa: </span>
                <mat-form-field appearance="outline" class="latitud-value marginTop10" *ngIf="addressData">
                    <input matInput type="text" [readonly]="true" value="{{addressData}}"/>
                </mat-form-field>
                <mat-form-field appearance="outline" class="latitud-value marginTop10" *ngIf="!addressData">
                    <input matInput type="text" [readonly]="true" value="No hay datos disponibles"/>
                </mat-form-field>
            </div>

            <div>
                <span class="labelCustom" [ngClass]="{'error-select': showClienteError}">Cliente: * </span>
                <mat-form-field class="formFieldCustom">
                    <mat-label [ngClass]="{'error-select': showClienteError}">-Elige una opción-</mat-label>
                    <mat-select [(value)]="selectedCliente" name="est" (selectionChange)="updateEstadoErrorCliente()">
                        <mat-option *ngFor="let est of clientes" [value]="est.value">
                        {{est.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-error *ngIf="showClienteError"  class="customError">Selecciona un cliente</mat-error>
            </div>

            <!--<div class="imagen-container">
                <span class="labelCustom">Imagen: </span><span>Imagen en formato horizontal. (Sólo JPG)</span>
                <div>
                    <input type="file" id="image_uploads" (change)="onFileSelected($event)" accept="image/jpeg" style="margin-top: 20px;">
                </div>
                <img *ngIf="imageUrl" [src]="imageUrl" alt="Vista previa de imagen dispositivo" class="imagen-dispositivo">
                <div class="showImageErrorMessage-container" style="margin-top: 12px;">
                    <span *ngIf="showImageErrorMessage" style="color: rgba(255, 0, 0, 0.993); font-size: 14px;">Por favor, seleccione un archivo .jpg</span>
                </div>
            </div>-->
        </div>
    </div>
</div>
<div class="footer"></div>